<template>
  <div id="container">
    <div id="studyObjectiveContainer">
      <header class="mdc-top-app-bar bg-contentBg">
        <div class="mdc-top-app-bar__row">
          <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
            <a class="material-icons mdc-top-app-bar__navigation-icon" tabindex="0" @click="moveLearnView()" @keypress="moveLearnView()">close</a>
          </section>

          <section class="mdc-top-app-bar__section title">
            <div class="mdc-top-app-bar__title">
              {{ $t('1046') }}
              <!-- Learning Objectives -->
            </div>
          </section>

          <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
            <a alt="search" aria-label="search" class="material-icons mdc-top-app-bar__action-item"></a>
          </section>
        </div>

      </header>

      <span class="lesson-title typography--h10 text-center">
				{{ name }}
			</span>
      <div v-if="teacherName">
				<span class="typography--b4">
					{{ $t('1047') }}
          <!-- by -->
				</span>
        <span class="typography--b5">
					{{ teacherName }}
				</span>
      </div>
      <section class="objectives">
        <div>
          <div class="t-body5">
            {{ learnPurposes }}
          </div>
        </div>
      </section>
      <div class="pdl-16 pdr-16">
        <button class="btn-submit mdc-button w-full" tabindex="0" @click="startStudy" @keypress="startStudy">
          {{ $t('1048') }}
          <!-- Start -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 인트로 컴포넌트(my learning lesson study - intro component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import {MDCRipple} from '@material/ripple'
import localStorageUtil from "@/utils/localStorageUtil";

export default {

  data() {
    return {
      name: '',
      teacherName: '',
      learnPurposes: '',
      objectiveData: null
    }
  },

  watch: {
    '$route'(to, from) {
      this.fatchData()
    }
  },

  created() {
    this.fatchData()
  },

  mounted() {
    this.setMaterialUi()
  },
  
  methods: {
    fatchData() {
      let params = this.setParams()

      learnApi.openNextLearning(this.$route.params.learnId)
        .then((res) => {
          console.log("OPEN NEXT LEARNING : ", res);
          // 학습목표 API 호출(get Learning Objectives)
          learnApi.learnLessonObjective(params).then((response) => {
            let responseData = response.data.data
            //console.log(responseData);
            this.objectiveData = responseData
            this.name = this.objectiveData.name
            this.teacherName = this.objectiveData.teacher ? this.objectiveData.teacher.fullName : ''
            this.learnPurposes = this.getLearnPurposes(this.objectiveData.learnInfo)
          })
        })
        .catch((err) => {
          console.log("ERROR OPEN NEXT LEARNING API : ", err)
        });
    },

    // 학습 시작(start learing)
    startStudy() {
      let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
      let goBackLikeLessson = localStorage.getItem('likeLesson')
      if (goBackBookMarkLessson == 'setGoBackBookMarkLesson') {
        localStorage.removeItem('bookMarkLesson');
        localStorage.setItem('videoBookMarkLesson', 'setVideoBookMarkLesson')
      } else if (goBackLikeLessson == 'setlikeLesson') {
        localStorage.removeItem('likeLesson');
        localStorage.setItem('videoLikeLesson', 'setVideoLikeLesson')
      }
      this.$emit('startStudy')
    },

    // 나의 학습 상세로 이동(Move to my Learning view)
    moveLearnView() {
      let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
      let goBackLikeLessson = localStorage.getItem('likeLesson')
      //let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
      if (goBackBookMarkLessson == 'setGoBackBookMarkLesson') {
        localStorage.removeItem('bookMarkLesson');
        this.$router.push({
          name: 'BookMarkedLesson'
        })
      } else if (goBackLikeLessson == 'setlikeLesson') {
        localStorage.removeItem('likeLesson');
        this.$router.push({
          name: 'LikedLesson'
        })
      } else {
        this.$router.push({
          name: 'LearnView',
          params: {learnId: this.$route.params.learnId},
          query: this.$route.query
        })
      }
    },

    // API 호출 파라미터 설정(set parameter)
    setParams() {
      let params = {
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      }

      return params
    },

    // get learning Purpose
    getLearnPurposes(obj) {
      const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
      const learnInfo = obj.find(info => info.lang.value === languageInfo.code);
      return learnInfo ? learnInfo.summary : "";
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
  },
}
</script>
